import { Box, Typography } from "@mui/material";
import { FC } from "react";
import imgHome from '../../images/logo.png';

const Home: FC = () => {
	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: "column", alignItems: 'center', height: '100vh' }}>
			<img
				src={imgHome}
				alt="Logo da Empresa"
				className="company-logo"
			/>
			<Typography variant="h5" fontFamily="revert-layer">Formulários</Typography>
		</Box>
	)
}

export default Home;